import BasePage from "../../../base/BasePage";
import React from "react";
import RegionTab from "../../../components/common/RegionTab";
import TrainingListPage from "./TrainingTable/TrainingListPage";
import Trainees from "./TrainingTable/Trainees";

class TrainingManagementPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Training List", content: <TrainingListPage /> },
      { title: "Trainees", content: <Trainees /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Learning and Development &gt;{" "}
              <span style={{ color: "#333" }}>Training</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default TrainingManagementPage;
